import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  getUsers,
  setSelectUserEdit,
  deleteUser,
  unsetSelectUserEdit,
  setSelectUserChangePassword,
  unsetSelectUserChangePassword,
  editStatusUser
} from "../../actions/UsersAction";
import {
  Table,
  // Divider,
  Modal,
  Icon,
  Button,
  Popconfirm,
  Select,
  Checkbox,
  Tooltip,
  Popover
} from "antd";
import { sendNotification, getWithDrawer } from "../../utils";
import Invitation from "./Invitation";
import Create from "./Create";
import Edit from "./Edit";
import ChangePassword from "./ChangePassword";
import ListSearcher from "../searcher/ListSearcher";
import BunkeyUsersTour from "../tour/BunkeyUsersTour";
import "./Users.css";
import { getPlanServicesByUser } from "../../actions/PlanServicesAction";
import NewInvitation from "./NewInvitation";
// import { usersSteps } from '../tour/TourUtils'

const ButtonGroup = Button.Group;
export class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNewUser: false,
      showInvitationUser: false,
      showEditUser: false,
      showDeleteUser: false,
      showChangePassword: false,
      userSelected: null,
      removeUsersGroups: null,
      showModal: false,
      nameUSer: null,
      modal: false,
      fRole: "all",
      fStatus: "all",
      fType: "all",
      fNameOrEmail: "",
      showAddModalUser: false,
      showUsersTour: true,
      usersTourStep: 0,
      popupOpen: false
    };
    const { intl } = this.props;
    this.addModalUserRef = React.createRef();

    this.columns = [
      {
        title: intl.formatMessage({ id: "name" }),
        dataIndex: "name",
        // fixed: 'left',
        key: "name",
        sorter: (a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "1",
        sorter: (a, b) => (a.email < b.email ? -1 : a.email > b.email ? 1 : 0)
      },
      {
        title: intl.formatMessage({ id: "role" }),
        dataIndex: "clientRoleTrad",
        key: "2",
        sorter: (a, b) =>
          a.clientRoleTrad < b.clientRoleTrad
            ? -1
            : a.clientRoleTrad > b.clientRoleTrad
              ? 1
              : 0
      },
      {
        title: intl.formatMessage({ id: "type" }),
        dataIndex: "typeRoleFilter",
        key: "3",
        width: 100,
        sorter: (a, b) =>
          a.typeRoleFilter < b.typeRoleFilter || !a.typeRoleFilter
            ? -1
            : a.typeRoleFilter > b.typeRoleFilter || !b.typeRoleFilter
              ? 1
              : 0,
        render: typeRoleFilter => (
          <p>
            {typeRoleFilter === "Temporary"
              ? intl.formatMessage({ id: "invitation_type_user_temporary" })
              : intl.formatMessage({ id: "invitation_type_user_infinite" })}
          </p>
        )
      },
      {
        title: intl.formatMessage({ id: "clients_status" }),
        dataIndex: "status",
        width: 80,
        align: "center",
        key: "4",
        render: status => <Checkbox checked={status}></Checkbox>
      },
      {
        title: intl.formatMessage({ id: "creation_date" }),
        dataIndex: "createdAtFormat",
        key: "5",
        align: "center",
        sorter: (a, b) =>
          a.createdAtFormat < b.createdAtFormat
            ? -1
            : a.createdAtFormat > b.createdAtFormat
              ? 1
              : 0
      },
      {
        title: intl.formatMessage({ id: "expDate" }),
        dataIndex: "dueDateFormat",
        key: "6",
        align: "center",
        sorter: (a, b) =>
          a.dueDateFormat < b.dueDateFormat
            ? -1
            : a.dueDateFormat > b.dueDateFormat
              ? 1
              : 0
      },
      {
        title: intl.formatMessage({ id: "action" }),
        dataIndex: ["groups"],
        fixed: "right",
        key: "operation",
        width: 220,
        render: (groups, record) => (
          <span>
            <ButtonGroup>
              <Tooltip title={intl.formatMessage({ id: "edit_asset" })}>
                <Button
                  type="default"
                  onClick={() => {
                    this.handleEditUser();
                  }}
                >
                  <Icon type="edit" />
                </Button>
              </Tooltip>

              {
                <Popconfirm
                  placement="topLeft"
                  title={intl.formatMessage({
                    id: record.status
                      ? "message_disabled_user"
                      : "message_enabled_user"
                  })}
                  onConfirm={() => {
                    if (
                      this.props.data.length === 1 &&
                      record._id === this.props.user._id
                    ) {
                      sendNotification(
                        "error",
                        intl,
                        intl.formatMessage({ id: "unabled-deactivate" })
                      );
                      return;
                    }
                    this.handleEditStatusUser(record._id, record.status);
                  }}
                  okText={intl.formatMessage({ id: "yes" })}
                  cancelText="No"
                >
                  <Tooltip
                    title={intl.formatMessage({
                      id: record.status
                        ? "module_deactivate"
                        : "module_activate"
                    })}
                  >
                    <Button onClick={this.handleConfirmGroups} type="default">
                      {record.status ? (
                        <Icon type="user-delete" />
                      ) : (
                        <Icon type="user-add" />
                      )}
                    </Button>
                  </Tooltip>
                </Popconfirm>
              }

              <Tooltip title={intl.formatMessage({ id: "change_password" })}>
                <Button
                  type="default"
                  onClick={() => {
                    this.handleChangePasswordUser();
                  }}
                >
                  <Icon type="setting" />
                </Button>
              </Tooltip>

              {record.roleLower === "operator" && (
                <Tooltip
                  placement="topLeft"
                  title={intl.formatMessage({ id: "groups" })}
                >
                  <Popover
                    content={
                      <div>
                        {groups &&
                          groups.length > 0 &&
                          groups.map((group, k) => <p key={k}>{group}</p>)}
                        {groups && groups.length === 0 && (
                          <p style={{ color: "red" }}>
                            <strong>N/A</strong>
                          </p>
                        )}
                      </div>
                    }
                    title={<span>Grupos</span>}
                    placement="rightBottom"
                  >
                    <Button type="default">
                      <React.Fragment>
                        <div>
                          <svg
                            style={{ verticalAlign: "middle" }}
                            width="15"
                            height="15"
                            viewBox="0 0 23 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M12.8326 4.3271C12.3879 5.09735 11.403 5.36125 10.6327 4.91655C9.86246 4.47185 9.59856 3.48694 10.0433 2.71669C10.488 1.94645 11.4729 1.68254 12.2431 2.12724C13.0134 2.57195 13.2773 3.55686 12.8326 4.3271ZM14.3048 5.1771C13.3907 6.76045 11.3661 7.30294 9.78271 6.3888C9.18214 6.04206 8.73131 5.53555 8.45293 4.95395C5.60973 6.18035 3.61958 9.00867 3.61958 12.3018C3.61958 12.7578 3.65773 13.2048 3.73101 13.6399C4.38524 13.582 5.06316 13.7177 5.67515 14.071C7.25849 14.9852 7.80099 17.0098 6.88684 18.5931C6.86544 18.6302 6.84342 18.6667 6.82082 18.7026C8.15733 19.7059 9.81831 20.3004 11.6181 20.3004C13.2755 20.3004 14.8152 19.7963 16.0921 18.9331C15.3158 17.9039 15.1828 16.4694 15.8679 15.2827C16.6159 13.9871 18.1075 13.3884 19.4924 13.7145C19.5741 13.2559 19.6167 12.7838 19.6167 12.3018C19.6167 8.89245 17.4836 5.98129 14.4792 4.83014C14.4285 4.94768 14.3704 5.06353 14.3048 5.1771ZM14.7229 3.11085C14.5979 2.11829 14.0263 1.19378 13.0931 0.655001C11.5098 -0.259143 9.48516 0.28335 8.57102 1.86669C8.31865 2.30381 8.1773 2.77455 8.13822 3.24627C4.50094 4.64492 1.91958 8.17192 1.91958 12.3018C1.91958 12.9627 1.98568 13.6082 2.11164 14.2319C1.731 14.5 1.40113 14.853 1.15305 15.2827C0.238904 16.8661 0.781397 18.8907 2.36474 19.8048C3.38309 20.3928 4.58397 20.3781 5.55455 19.8716C7.21525 21.2036 9.32364 22.0004 11.6181 22.0004C13.8313 22.0004 15.8713 21.2591 17.5034 20.0112C19.0081 20.6163 20.7674 20.0382 21.6017 18.5931C22.3741 17.2553 22.1066 15.6024 21.0499 14.5706C21.2243 13.8428 21.3167 13.0831 21.3167 12.3018C21.3167 8.03128 18.5566 4.40541 14.7229 3.11085ZM5.4146 17.7431C4.9699 18.5134 3.98499 18.7773 3.21474 18.3326C2.44449 17.8879 2.18059 16.903 2.62529 16.1327C3.06999 15.3625 4.0549 15.0986 4.82515 15.5433C5.5954 15.988 5.8593 16.9729 5.4146 17.7431ZM17.9296 18.3326C18.6998 18.7773 19.6847 18.5134 20.1294 17.7431C20.5741 16.9729 20.3102 15.988 19.54 15.5433C18.7697 15.0986 17.7848 15.3625 17.3401 16.1327C16.8954 16.903 17.1593 17.8879 17.9296 18.3326Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                      </React.Fragment>
                    </Button>
                  </Popover>
                </Tooltip>
              )}
            </ButtonGroup>
          </span>
        )
      }
    ];
  }

  componentDidMount() {
    const { workclient } = this.props;
    this.props.getPlanServicesByUser(workclient);
    this.setState({
      showEditUser: false,
      showChangePassword: false
    });
    this.handleGetData();
  }

  componentDidUpdate(prevProps) {
    const { deleteStatus, intl } = this.props;
    if (prevProps.deleteStatus !== deleteStatus) {
      if (deleteStatus === "success") {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "delete_user_success" })
        );
        this.handleGetData();
      } else if (deleteStatus === "failed") {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "delete_user_error" })
        );
      }
    }
  }

  handleGetData = () => {
    const { workclient } = this.props;
    this.props.getUsers(workclient, 1, null, true);
  };

  handleShowNewUser = () => {
    const { contractedUsers, data, intl } = this.props;

    const registeredUsers = data.filter(
      user =>
        user.status &&
        user.typeRoleFilter === "Infinite" &&
        user.email.indexOf("@bunkey.tv") === -1 &&
        user.roleLower !== "superadmin"
    ).length;
    //alert(registeredUsers+'/'+contractedUsers)
    if (registeredUsers < contractedUsers) {
      this.setState({
        showNewUser: true
      });
    } else {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "user_max_limit" })
      );
    }
  };

  handleHideNewUser = () => {
    this.setState({
      showNewUser: false
    });
  };

  handleEditUser = () => {
    const { userSelected } = this.state;
    this.props.setSelectUserEdit(userSelected);
    this.setState({
      showEditUser: true,
      showUsersTour: true
    });
  };

  handleChangePasswordUser = () => {
    const { userSelected } = this.state;
    this.props.setSelectUserChangePassword(userSelected);
    this.setState({
      showChangePassword: true
    });
  };

  handleHideChangePasswordUser = () => {
    this.props.unsetSelectUserChangePassword();
    this.setState({
      showChangePassword: false
    });
  };

  handleDeleteUser = () => {
    const { userSelected, removeUsersGroups } = this.state;
    const { workclient } = this.props;

    if (removeUsersGroups.length > 0) {
      this.setState({
        modal: true
      });
    } else {
      this.props.deleteUser(workclient, userSelected);
    }
  };

  handleShowDetail = id => {
    this.props.history.push(`/home/groups/${id}`);
    this.handleClose();
  };

  handleClose = () => {
    this.setState({
      modal: false
    });
  };

  handleSetUser = key => {
    this.setState({
      userSelected: key
    });
  };

  handleHideInvitationUser = () => {
    this.setState({
      showInvitationUser: false
    });
  };

  handleShowInvitationUser = () => {
    const { contractedUsers, data, intl } = this.props;

    const registeredUsers = data.filter(
      user =>
        user.status &&
        user.typeRoleFilter === "Infinite" &&
        user.email.indexOf("@bunkey.tv") === -1 &&
        user.roleLower !== "superadmin"
    ).length;
    //alert(registeredUsers+'/'+contractedUsers)
    if (registeredUsers < contractedUsers) {
      this.setState({
        showInvitationUser: true
      });
    } else {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "user_max_limit" })
      );
    }
  };

  handleHideEditUser = () => {
    this.props.unsetSelectUserEdit();
    this.setState({
      showEditUser: false
    });
  };

  handleConfirmGroups = () => {
    const { userSelected } = this.state;
    const { byClientData, data } = this.props;

    this.setState({
      removeUsersGroups: byClientData.filter(
        r => r.userCreator.id === userSelected
      ),
      nameUSer: data.filter(r => r._id === userSelected).map(r => r.name)
    });
  };

  filterRoles = value => {
    this.setState({ fRole: value });
  };

  filterStatus = value => {
    this.setState({ fStatus: value });
  };

  filterType = value => {
    this.setState({ fType: value });
  };

  filterByNameOrEmail = e => {
    const { value } = e.target;
    this.setState({ fNameOrEmail: value ? value.toString().trim() : "" });
  };

  handleOnSearch = () => {
    this.setState({ fNameOrEmail: "" });
  };

  handleOnchageSearch = e => {
    this.setState({ fNameOrEmail: e.target.value });
  };

  handleEditStatusUser = (userId, status) => {
    const { workclient } = this.props;
    this.props.editStatusUser(workclient, userId, !status);
  };
  handleShowAddModalUser = () => {
    this.setState({
      showAddModalUser: true
    });
  };
  handleHiddenAddModalUser = () => {
    this.setState({
      showAddModalUser: false
    });
  };
  render() {
    const {
      data,
      isFetching,
      width,
      newColor,
      isDeleting,
      user,
      intl,
      workclient,
      contractedUsers,
      tourUsers
    } = this.props;
    const {
      showInvitationUser,
      showEditUser,
      showNewUser,
      showChangePassword,
      removeUsersGroups,
      modal,
      nameUSer,
      fRole,
      fStatus,
      fType,
      fNameOrEmail,
      showAddModalUser,
      showUsersTour,
      usersTourStep,
      popupOpen
    } = this.state;

    const isMobileTable = width ? (width <= 768 ? true : false) : false;

    const { Option } = Select;

    /* FILTERS USERS*/

    let isAdmin = true;

    if (user.role === "admin" && user.clientRole === "admin") isAdmin = false;

    //Funcion para quitar las tildes de un texto
    const removeAccents = text => {
      return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const dataFilter = data
      .map(d => {
        const rgx = new RegExp(
          removeAccents(fNameOrEmail).replace(/[^a-zA-Z0-9]/g, ""),
          "gi"
        );

        if (fRole !== "all" && fRole !== d.roleLower) return null;
        else if (fStatus !== "all" && JSON.parse(fStatus) !== d.status)
          return null;
        else if (fType !== "all" && fType !== d.typeRoleFilter) return null;
        else if (
          fNameOrEmail !== "" &&
          !rgx.test(removeAccents(d.name)) &&
          !rgx.test(removeAccents(d.email))
        )
          return null;
        else if (isAdmin && d.roleLower === "superadmin") return null;
        else return d;
      })
      .filter(d => d);

    const usersTop = data.filter(
      user =>
        user.status &&
        user.typeRoleFilter === "Infinite" &&
        user.email.indexOf("@bunkey.tv") === -1 &&
        user.roleLower !== "superadmin"
    ).length;

    return (
      <React.Fragment>
        {/* tourUsers.length !== 0 */}
        {showUsersTour && (
          <BunkeyUsersTour
            onAfterOpen={() => {
              this.setState({
                usersTourStep: 0
              });
            }}
            onChangePage={newPage => {
              var step = 0;
              if (tourUsers && tourUsers.length !== 0) {
                step = 5 - tourUsers.length;
              }
              if (newPage !== usersTourStep) {
                this.setState({
                  usersTourStep: newPage
                });
                if (newPage + step === 2) {
                  const userId = dataFilter[0]._id;
                  this.handleSetUser(userId);
                  this.handleEditUser();
                }
                if (newPage + step === 3) {
                  this.setState({
                    popupOpen: true
                  });
                }
                if (newPage + step === 4) {
                  const userId = dataFilter[0]._id;
                  this.handleSetUser(userId);
                  this.handleChangePasswordUser();
                }
              }
              if (newPage + step !== 2 && usersTourStep + step === 2) {
                this.handleHideEditUser();
                //Limpiar lo hecho en el paso 2
              }
              if (newPage + step !== 3 && usersTourStep + step === 3) {
                this.setState({
                  popupOpen: false
                });
              }
              if (newPage + step !== 4 && usersTourStep + step === 4) {
                this.handleHideChangePasswordUser();
                //Limpiar lo hecho en el paso 2
              }
            }}
            onRequestClose={() => {
              const newPage = this.state.usersTourStep;
              var step = 0;
              if (tourUsers && tourUsers.length !== 0) {
                step = 5 - tourUsers.length;
              }
              if (newPage + step === 2) {
                this.handleHideEditUser();
              }
              if (newPage + step === 3) {
                this.setState({
                  popupOpen: false
                });
              }
              if (newPage + step === 4) {
                this.handleHideChangePasswordUser();
              }
              setTimeout(() => {
                document.body.style.overflow = "auto";
              }, 1000);
            }}
          />
        )}
        <div className="title-bar">
          <div className="container" style={{ borderLeftColor: newColor }}>
            <span
              style={
                contractedUsers && usersTop >= contractedUsers
                  ? { color: "red" }
                  : {}
              }
              className="users-page-title"
            >
              {intl.formatMessage({ id: "users" }) +
                ` ${usersTop + "/" + contractedUsers}`}
            </span>
            {contractedUsers && usersTop >= contractedUsers && (
              <Tooltip
                title={intl.formatMessage({ id: "info_user_max_limit" })}
                placement="right"
              >
                <Icon
                  style={{ fontSize: "16px", margin: "10px", color: "#F0BB62" }}
                  type="info-circle"
                />
              </Tooltip>
            )}

            <div
              style={{
                display: "block",
                float: "right",
                marginRight: 15,
                marginTop: 10
              }}
            >
              <button
                onClick={this.handleShowAddModalUser}
                style={{
                  backgroundColor: newColor,
                  borderColor: newColor,
                  marginRight: 10
                }}
                className="ant-btn ant-btn-primary users-page-invite"
              >
                {intl.formatMessage({ id: "invite_user" })}
              </button>
              {user.role === "admin" && (
                <button
                  onClick={this.handleShowNewUser}
                  style={{ backgroundColor: newColor, borderColor: newColor }}
                  className="ant-btn ant-btn-primary"
                >
                  {intl.formatMessage({ id: "create_user" })}
                </button>
              )}
            </div>
          </div>
        </div>
        {removeUsersGroups && (
          <Modal
            title={"Eliminar Usuario"}
            visible={modal}
            width={700}
            footer={null}
          >
            {
              <div
                style={{
                  padding: "10px",
                  paddingBottom: 10,
                  border: "1px solid #91d5ff",
                  marginBottom: "13px",
                  backgroundColor: "#e6f7ff",
                  display: "flex"
                }}
              >
                <Icon type="info-circle" style={{ color: "#1890ff" }} />
                <div style={{ marginLeft: "10px" }}>
                  El usuario {nameUSer} es administrador de los siguientes
                  grupos. Debes seleccionar un nuevo administrador antes de
                  eliminar
                </div>
              </div>
            }
            {removeUsersGroups.map((r, k) => {
              return (
                <ul key={k}>
                  <li
                    style={{
                      color: "#1884dd",
                      cursor: "pointer",
                      textDecoration: "underline"
                    }}
                    onClick={() => this.handleShowDetail(r._id)}
                  >
                    {r.name}
                  </li>
                </ul>
              );
            })}
            {
              <Button
                type="primary"
                style={{ marginLeft: "94%" }}
                size="small"
                onClick={this.handleClose}
              >
                OK
              </Button>
            }
          </Modal>
        )}
        <div className="assets-wrapper">
          <div className="container">
            <div className="filter-user">
              <ListSearcher
                client={workclient}
                placeholder={intl.formatMessage({
                  id: "enter_text_to_search_for_user"
                })}
                type={"users"}
                loading={isFetching}
                searchButtonText={intl.formatMessage({ id: "all" })}
                filterByNameOrEmail={this.filterByNameOrEmail}
                handleOnSearch={this.handleOnSearch}
                fNameOrEmail={fNameOrEmail}
                handleOnchageSearch={this.handleOnchageSearch}
              />

              <Select
                placeholder={intl.formatMessage({ id: "role" })}
                onChange={this.filterRoles}
                style={{ width: 150, marginRight: "30px" }}
              >
                <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
                {!isAdmin && (
                  <Option value="superadmin">
                    {intl.formatMessage({ id: "super_admin" })}
                  </Option>
                )}
                <Option value="admin">
                  {intl.formatMessage({ id: "administrators" })}
                </Option>
                <Option value="operator">
                  {intl.formatMessage({ id: "operators" })}
                </Option>
              </Select>
              <Select
                placeholder={intl.formatMessage({ id: "clients_status" })}
                onChange={this.filterStatus}
                style={{ width: 120, marginRight: "30px" }}
              >
                <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
                <Option value="true">
                  {intl.formatMessage({ id: "activated" })}
                </Option>
                <Option value="false">
                  {intl.formatMessage({ id: "deactivated" })}
                </Option>
              </Select>
              <Select
                placeholder={intl.formatMessage({ id: "type" })}
                onChange={this.filterType}
                style={{ width: 120 }}
              >
                <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
                <Option value="Infinite">
                  {intl.formatMessage({ id: "invitation_type_user_infinite" })}
                </Option>
                <Option value="Temporary">
                  {intl.formatMessage({ id: "invitation_type_user_temporary" })}
                </Option>
              </Select>
            </div>
            {/* Solo visual */}
            {popupOpen && (
              <div className="container-popconfirm-main">
                <div className="users-page-desactive-user"></div>
                <Popconfirm
                  placement="topLeft"
                  title={intl.formatMessage({ id: "message_enabled_user" })}
                  onConfirm={() => { }}
                  okText={intl.formatMessage({ id: "yes" })}
                  cancelText="No"
                  visible={popupOpen}
                >
                  <div className="cont-popconfirm"></div>
                </Popconfirm>
              </div>
            )}
            {!isMobileTable && (
              <Table
                bordered
                loading={isFetching || isDeleting}
                rowKey="_id"
                onRow={record => ({
                  onMouseEnter: () => {
                    document.body.style.cursor = "pointer";
                    this.handleSetUser(record._id);
                  },
                  onMouseLeave: () => {
                    document.body.style.cursor = "default";
                  }
                })}
                columns={this.columns}
                dataSource={dataFilter}
                scroll={{ x: 1500 }}
              />
            )}
            {isMobileTable && (
              <Table
                bordered
                loading={isFetching || isDeleting}
                onRow={record => ({
                  onMouseEnter: () => {
                    document.body.style.cursor = "pointer";
                    this.handleSetUser(record._id);
                  },
                  onMouseLeave: () => {
                    document.body.style.cursor = "default";
                  }
                })}
                rowKey="_id"
                columns={this.columns.filter(r =>
                  ["name", "action"].includes(r.dataIndex)
                )}
                dataSource={dataFilter}
                scroll={{ x: 1500 }}
              />
            )}
          </div>
        </div>
        <Modal
          title={intl.formatMessage({ id: "new_user" })}
          width={getWithDrawer()}
          closable={true}
          footer={null}
          onCancel={this.handleHideNewUser}
          onClose={this.handleHideNewUser}
          visible={showNewUser}
        >
          {showNewUser && (
            <Create handleHideCreateUser={this.handleHideNewUser} />
          )}
        </Modal>
        <Modal
          title={intl.formatMessage({ id: "send_invitation" })}
          width={getWithDrawer()}
          closable={true}
          footer={null}
          onCancel={this.handleHideInvitationUser}
          onClose={this.handleHideInvitationUser}
          visible={showInvitationUser}
        >
          {showInvitationUser && (
            <Invitation
              handleHideinvitationUser={this.handleHideInvitationUser}
            />
          )}
        </Modal>
        <Modal
          className="users-page-edit-user"
          title={intl.formatMessage({ id: "edit_user" })}
          placement="right"
          width={getWithDrawer()}
          closable={true}
          footer={null}
          onCancel={this.handleHideEditUser}
          onClose={this.handleHideEditUser}
          visible={showEditUser}
        >
          <Edit handleHideEditUser={this.handleHideEditUser} />
        </Modal>
        <Modal
          className="users-page-change-password"
          title={intl.formatMessage({ id: "change_password" })}
          placement="right"
          width={getWithDrawer()}
          closable={true}
          onCancel={this.handleHideChangePasswordUser}
          onClose={this.handleHideChangePasswordUser}
          footer={null}
          visible={showChangePassword}
        >
          <ChangePassword
            handleHideChangePasswordUser={this.handleHideChangePasswordUser}
            showChangePassword={showChangePassword}
            close={() => {
              this.handleHideChangePasswordUser();
            }}
          />
        </Modal>
        <NewInvitation
          showAddModalUser={showAddModalUser}
          handleShowAddModalUser={this.handleShowAddModalUser}
          handleHiddenAddModalUser={this.handleHiddenAddModalUser}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    width: state.app.width,
    workclient: state.client.workclient,
    contractedUsers:
      state.client && state.client.data
        ? state.client.data.contractedUsers
        : null,
    data: state.users.data,
    user: state.authUser.user,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    isFetching: state.users.isFetching,
    userEditSelected: state.users.data.find(r => r.isEditSelected),
    userChangePassword: state.users.data.find(r => r.isChangePasswordSelected),
    isUpdating: state.users.isUpdating,
    isDeleting: state.users.isDeleting,
    deleteStatus: state.users.deleteStatus,
    byClientData: state.group.byClientData,
    tourUsers: state.tours.tourUsers
  };
};

const mapDispatchToProps = {
  getUsers,
  setSelectUserEdit,
  unsetSelectUserEdit,
  deleteUser,
  setSelectUserChangePassword,
  unsetSelectUserChangePassword,
  editStatusUser,
  getPlanServicesByUser
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Users))
);
